// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"319ed083","732":"99117798"}[chunkId] + ".chunk.js";
};